import { render, staticRenderFns } from "./ListItemFull.vue?vue&type=template&id=d2642182&"
import script from "./ListItemFull.vue?vue&type=script&lang=js&"
export * from "./ListItemFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports